import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useIconProps } from '../useIconProps';

var FeedbackSuccess = function FeedbackSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M9.33 18.216l-5.436-5.718a.866.866 0 01-.227-.62c0-.253.076-.46.227-.62l1.205-1.24a.694.694 0 01.553-.276c.239 0 .445.092.619.276l3.646 3.858 7.812-8.267c.174-.184.369-.276.586-.276.239 0 .434.092.586.276l1.204 1.24c.152.16.228.367.228.62s-.076.46-.228.62l-9.602 10.127a.726.726 0 01-.586.275.726.726 0 01-.586-.275z"
  }));
};

FeedbackSuccess.displayName = 'FeedbackSuccess';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  FeedbackSuccess.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default FeedbackSuccess;